'use client';

import { useCallback, useMemo } from 'react';
import { isCellAvailable } from '@modules/garden-planner/garden_grid/business_logic';
import { GardenGridView } from '@modules/garden-planner/views/garden_grid_view';
import type { GardenGridReadOnlyProps } from '@modules/shared-garden/containers/garden_grid_read_only_container';

const EMPTY_BULK_KEYS = new Set<string>();

export function GardenGridReadOnly({
  rows,
  columns,
  plants,
  availableCells,
  getSlotsForCell,
  plantsList,
}: GardenGridReadOnlyProps) {
  const handleCellClick = useCallback(() => {}, []);
  const bulkSelectedKeys = useMemo(() => EMPTY_BULK_KEYS, []);

  return (
    <GardenGridView
      rows={rows}
      columns={columns}
      availableCells={availableCells}
      plantedPlants={plants}
      plants={plantsList}
      selectedPlant={null}
      isAvailabilityMode={false}
      isCellSettingsMode={false}
      isClearMode={false}
      getSlotsForCell={getSlotsForCell}
      handleCellClick={handleCellClick}
      isCellAvailable={isCellAvailable}
      isBulkEditMode={false}
      bulkSelectedKeys={bulkSelectedKeys}
    />
  );
}
